export default __webpack_public_path__ + "images/52a329b1ce1e17b684d0357a24a776de.svg";